import styled from "styled-components";
import {
  colorBrandPrimary,
  fontFamily,
  fontSize,
  colorBrandSecondary,
} from "src/global.style";

export const CardContainer = styled.div`
  display: flex;
  align-items: center;
  height: 100px;
  width: 20%;
  padding: 0 16px;
  border-radius: 16px;
  background-color: #ffffff;
  box-shadow: 1px 4px 8px #00000033;
  flex-direction: column;
  justify-content: center;

  @media only screen and (max-width: 1100px) and (min-width: 1000px) {
    height: 135px;
  }
`;

export const CardTitle = styled.h3`
  margin-bottom: 8px;
  color: ${colorBrandPrimary.marine};
  font-family: 24px;
  font-size: ${fontSize.sm};
  letter-spacing: 0;
  line-height: 24px;
  font-weight: 600;
`;

export const CardSubtitle = styled.h4`
  color: ${colorBrandPrimary.marine};
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 22px;
`;

export const CardText = styled.div`
  color: ${colorBrandPrimary.marine};
  font-family: ${fontFamily.neutral};
  font-size: 16px;
  letter-spacing: 0;
  line-height: 24px;
  margin: 0;

  p {
    margin-bottom: 24px;

    &:last-child {
      margin-bottom: 0;

      &:not(:only-child) {
        a {
          font-weight: bold;
        }
      }
    }
  }

  a {
    color: ${colorBrandPrimary.marine};
  }
`;

export const TextContainer = styled.div`
  display: inline-flex;
  flex-direction: column;
  max-width: 360px;

  @media (min-width: 768px) {
    margin-left: 27px;
  }
`;
